import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default class AutomateRoute extends PermittedRoute {
  permission = 'automate';
}
